module.exports = __webpack_public_path__ + "static/media/CreateUncropped.f2bfa1ca.png";